import { StationNavigatorBreadcrumb } from '@app/components/base/stations/StationNavigatorBreadcrumb';
import { Page } from '@app/components/page/Page';
import { HotkeysDialog } from '@app/core/hotkeys/HotkeysDialog';
import { isVideoStation } from '@app/core/stations/helpers';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { LivePlayerToggle } from '@app/modules/live-player/LivePlayerToggle';
import { LoggerIcon } from '@app/modules/logger/LoggerIcon';
import { LoggerModule } from '../..';
import { streamHotkeys } from '../stream-hotkeys';
import { ConfigView } from './config/StreamConfigDialog';

export function LoggerStreamHeader() {
  const station = useActiveStation();

  return (
    <Page.Header
      icon={<LoggerIcon />}
      title={[
        LoggerModule.title,
        <StationNavigatorBreadcrumb
          key={station.id}
          basePath={LoggerModule.basePath}
          activeId={station.id}
        />,
      ]}
      actions={[
        <HotkeysDialog key="hotkeys" hotkeys={streamHotkeys} />,
        <ConfigView key="config-view" />,
        isVideoStation(station) ? <LivePlayerToggle key="live-player-toggle" /> : null,
      ]}
    />
  );
}
